export default __webpack_public_path__ + "static/media/gov-pakistan-white.10a405c8.png";